<!-- eslint-disable vue/v-on-event-hyphenation -->
<template>
  <div id="gfActions" class="d-flex align-items-center justify-content-end pr-1">
    <a
      v-show="!isInIframe"
      id="gf-save"
      class="gf-save-btn gf_action-item btn btn-secondary btn-default ml-1"
      data-saveType="save"
      :lock="isLockSavePublish"
      @click="savePage">
      <span>Save</span>
    </a>
    <!-- component :is="isSaved ? 'a': 'button'"  -->
    <a
      id="gf-preview"
      :href="bindingData('previewUrl')"
      :origin-href="bindingData('previewUrl')"
      class="gf-preview-btn gf_action-item btn btn-secondary btn-default ml-1"
      :class="{ 'gf-disabled_action': !bindingData('previewUrl') }"
      data-saveType="save"
      target="_blank"
      :disabled="!isSaved || !bindingData('previewUrl')"
      @click="previewPage">
      <span>Preview</span>
    </a>
    <button
      v-show="!isSchedulingPublish"
      id="gf-publish"
      class="gf-publish-btn gf_action-item btn btn-primary btn-default ml-1"
      data-saveType="publish"
      :lock="isLockSavePublish"
      :prevent="shouldDisablePublish"
      @click="publishPage">
      <span class="publish_text">Publish</span>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.64645 7.64645C4.84171 7.45118 5.15829 7.45118 5.35355 7.64645L10 12.2929L14.6464 7.64645C14.8417 7.45118 15.1583 7.45118 15.3536 7.64645C15.5488 7.84171 15.5488 8.15829 15.3536 8.35355L10.3536 13.3536C10.1583 13.5488 9.84171 13.5488 9.64645 13.3536L4.64645 8.35355C4.45118 8.15829 4.45118 7.84171 4.64645 7.64645Z"
          fill="white" />
      </svg>
    </button>
    <button
      v-show="isSchedulingPublish"
      class="gf_action-item btn btn-secondary btn-default text-accent-green ml-1"
      :class="{ 'schedule-publishing': schedule.publish.running }"
      @click="schedule.publish.running ? null : openSchedulePublish(false)">
      <template v-if="!schedule.publish.running">Scheduled</template>
      <template v-else>
        Publishing
        <div class="publish-overlay" :style="overlayStyle"></div>
      </template>
    </button>

    <button
      v-click-away="closeDropdown"
      class="gf_action-item gf_action-item--more dropdown_root btn btn-secondary btn-default min-40 ml-1"
      :class="{ active: dropdownActive }"
      title="More"
      @click.stop="toggleDropdown">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.13389 7.13126C2.64573 6.6431 1.85428 6.6431 1.36612 7.13126C0.87796 7.61941 0.87796 8.41086 1.36612 8.89902C1.85428 9.38718 2.64573 9.38718 3.13389 8.89902C3.62204 8.41086 3.62204 7.61941 3.13389 7.13126ZM3.84099 6.42415C2.96231 5.54547 1.53769 5.54547 0.659012 6.42415C-0.219671 7.30283 -0.219671 8.72745 0.659012 9.60613C1.53769 10.4848 2.96231 10.4848 3.84099 9.60613C4.71967 8.72745 4.71967 7.30283 3.84099 6.42415Z"
          fill="currentColor" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.6339 7.13126C14.1457 6.6431 13.3543 6.6431 12.8661 7.13126C12.378 7.61941 12.378 8.41086 12.8661 8.89902C13.3543 9.38718 14.1457 9.38718 14.6339 8.89902C15.122 8.41086 15.122 7.61941 14.6339 7.13126ZM12.159 6.42415C13.0377 5.54547 14.4623 5.54547 15.341 6.42415C16.2197 7.30283 16.2197 8.72745 15.341 9.60613C14.4623 10.4848 13.0377 10.4848 12.159 9.60613C11.2803 8.72745 11.2803 7.30283 12.159 6.42415Z"
          fill="currentColor" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.88389 7.13126C8.39573 6.6431 7.60428 6.6431 7.11612 7.13126C6.62796 7.61941 6.62796 8.41086 7.11612 8.89902C7.60428 9.38718 8.39573 9.38718 8.88389 8.89902C9.37204 8.41086 9.37204 7.61941 8.88389 7.13126ZM6.40901 6.42415C7.28769 5.54547 8.71231 5.54547 9.59099 6.42415C10.4697 7.30283 10.4697 8.72745 9.59099 9.60613C8.71231 10.4848 7.28769 10.4848 6.40901 9.60613C5.53033 8.72745 5.53033 7.30283 6.40901 6.42415Z"
          fill="currentColor" />
      </svg>
      <!-- <div class="new-feature"></div> -->

      <div class="dropdown_list" :class="{ show: dropdownActive }">
        <template v-if="showUpgrade">
          <a
            id="gf-upgrade"
            class="gf-upgrade-btn gf_action-item btn btn-warning btn-upgrade min-100 gp-open-new-tab"
            data-saveType="save"
            :data-href="bindingData('upgradeUrl')"
            @click="openUpgrade">
            <span>Upgrade Plan</span>
          </a>
          <hr class="divider" />
        </template>

        <a
          id="gf-view"
          :origin-href="bindingData('liveUrl')"
          class="gf_action-item dropdown_item typo-button14 typo-medium"
          title=""
          :class="{ 'gf-disabled_action': isDisabledViewLivePage }"
          @click="viewPage(bindingData('liveUrl'), $event)">
          <svg
            class="topbar preview"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.00023 3.00123C10.8966 2.95633 13.7998 4.95709 15.5864 6.9218L15.5881 6.92359C16.1393 7.53567 16.1393 8.46529 15.5881 9.07737L15.5866 9.07898C13.8407 11.0008 10.9445 13.0473 8.00022 13.0017C5.0559 13.0473 2.1604 11.0008 0.415719 9.07884L0.414392 9.07738L0.414395 9.07737C-0.13683 8.4653 -0.136829 7.53567 0.414394 6.92359L0.415819 6.92201L0.415822 6.92201C2.2006 4.95708 5.10386 2.95633 8.00023 3.00123ZM1.15683 7.5937C0.949069 7.82509 0.949082 8.17593 1.15687 8.4073C2.82938 10.2494 5.47251 12.0439 7.99181 12.0015H8.00864C10.5279 12.0439 13.1716 10.2495 14.8456 8.40732C15.0534 8.17596 15.0534 7.82515 14.8457 7.59376C13.1352 5.71319 10.4839 3.9597 8.00866 4.00146H7.99179C5.51646 3.9597 2.86517 5.7133 1.15683 7.5937Z"
              fill="#E2E2E2" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.0002 7.9992C9.99948 6.89486 9.10389 6.00014 7.99973 6.00073L7.99959 6.00073C6.89518 6.00102 6.00004 6.89658 6.00004 8.0012C6.00004 9.10603 6.89551 10.0017 8.00013 10.0017C9.10492 10.0017 10.0002 9.10653 10.0002 8.00187L10.0002 7.99947L10.0002 7.9992ZM7.99933 5.00049C9.65583 4.99968 10.9994 6.3421 11.0003 7.99893L11.0003 7.9992L11.0003 8.00187C11.0003 9.65929 9.65688 11.0019 8.00013 11.0019C6.3432 11.0019 5 9.65845 5 8.0012C5 6.34431 6.34264 5.001 7.99919 5.00049"
              fill="#E2E2E2" />
          </svg>

          <span class="ml-1">View Live Page</span>
        </a>

        <a
          v-if="shouldShowPreviewTemplate || true"
          id="gf-viewtemplate"
          :origin-href="bindingData('templateUrl')"
          target="_blank"
          class="gf_action-item dropdown_item typo-button14 typo-medium"
          :class="{ 'gf-disabled_action': !bindingData('templateUrl') }"
          title=""
          @click="viewTemplate(bindingData('templateUrl'), $event)">
          <svg
            class="topbar view-template"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.00032 15.9962C6.68495 15.9961 5.38992 15.6715 4.22995 15.0514C3.06997 14.4312 2.08085 13.5345 1.3502 12.4408C0.619557 11.3471 0.169935 10.0901 0.0411674 8.78108C-0.0876005 7.47209 0.10846 6.15155 0.611982 4.93642C1.1155 3.7213 1.91094 2.64911 2.92784 1.81482C3.94474 0.980533 5.15171 0.409901 6.44183 0.153471C7.73196 -0.102958 9.06541 -0.0372694 10.3241 0.344719C11.5828 0.726708 12.7278 1.4132 13.6578 2.3434C14.7773 3.46169 15.5398 4.88697 15.8488 6.43883C16.1578 7.99069 15.9994 9.59934 15.3937 11.0611C14.7879 12.5229 13.7621 13.7722 12.446 14.6507C11.1299 15.5291 9.58271 15.9974 8.00032 15.9962ZM8.00032 1.0001C6.38076 1.00022 4.81136 1.56186 3.5595 2.58934C2.30764 3.61681 1.45079 5.04654 1.13494 6.63493C0.819083 8.22331 1.06377 9.87207 1.82732 11.3003C2.59086 12.7285 3.82601 13.8478 5.32232 14.4674C6.81863 15.0871 8.48351 15.1688 10.0333 14.6986C11.5831 14.2284 12.9219 13.2354 13.8216 11.8888C14.7213 10.5422 15.1262 8.92528 14.9674 7.31361C14.8085 5.70193 14.0958 4.19519 12.9505 3.0501C12.302 2.39806 11.5305 1.88113 10.6808 1.52925C9.83107 1.17737 8.92 0.997513 8.00032 1.0001Z"
              fill="#E2E2E2" />
            <path
              d="M8.06232 11.501C8.01642 11.502 7.97101 11.501 7.92461 11.5C5.9546 11.3276 4.12757 10.4001 2.82579 8.91155C2.61754 8.68859 2.50171 8.39489 2.50171 8.0898C2.50171 7.78472 2.61754 7.49101 2.82579 7.26805C4.13002 5.77626 5.96234 4.84884 7.93681 4.68115C7.97831 4.68115 8.02082 4.68115 8.06382 4.68115C10.0388 4.84921 11.8716 5.7769 13.1763 7.26895C13.3844 7.49195 13.5001 7.78555 13.5001 8.0905C13.5001 8.39546 13.3844 8.68906 13.1763 8.91205C11.8699 10.4029 10.0373 11.3306 8.06232 11.501ZM7.99232 10.5C9.71641 10.3519 11.3146 9.53672 12.4466 8.22795C12.4815 8.19067 12.5008 8.14154 12.5008 8.0905C12.5008 8.03947 12.4815 7.99034 12.4466 7.95305C11.3215 6.64423 9.7281 5.8287 8.00842 5.68155H7.99202C6.2777 5.84462 4.69052 6.65669 3.55532 7.95155C3.52049 7.98894 3.50111 8.03815 3.50111 8.08925C3.50111 8.14036 3.52049 8.18956 3.55532 8.22695C4.68914 9.52433 6.27712 10.3378 7.99252 10.5H7.99232Z"
              fill="#E2E2E2" />
            <path
              d="M8.00032 9.58902C7.65347 9.58889 7.3174 9.4685 7.04936 9.24837C6.78133 9.02823 6.59792 8.72197 6.5304 8.38177C6.46287 8.04157 6.5154 7.68849 6.67904 7.38268C6.84268 7.07686 7.10729 6.83725 7.4278 6.70467C7.74831 6.57209 8.10488 6.55474 8.43675 6.65558C8.76861 6.75642 9.05525 6.96921 9.2478 7.25769C9.44036 7.54617 9.52692 7.89249 9.49275 8.23764C9.45857 8.58279 9.30576 8.9054 9.06037 9.15052C8.92121 9.28974 8.75594 9.40014 8.57404 9.47538C8.39214 9.55063 8.19718 9.58925 8.00032 9.58902ZM8.00032 7.59012C7.88463 7.59021 7.77255 7.63042 7.68318 7.70388C7.59381 7.77735 7.53268 7.87953 7.51022 7.99302C7.48775 8.10651 7.50533 8.22427 7.55997 8.32624C7.6146 8.42822 7.70291 8.50809 7.80984 8.55226C7.91677 8.59642 8.03571 8.60214 8.14639 8.56843C8.25706 8.53473 8.35262 8.46369 8.41679 8.36743C8.48095 8.27116 8.50975 8.15563 8.49827 8.04051C8.48679 7.9254 8.43575 7.81782 8.35384 7.73612C8.30744 7.68969 8.25233 7.65289 8.19166 7.62783C8.13099 7.60278 8.06596 7.58996 8.00032 7.59012Z"
              fill="#E2E2E2" />
          </svg>

          <span class="ml-1">View with current Template</span>
        </a>

        <a
          id="gf-library-export-new"
          class="gf_action-item dropdown_item typo-button14 typo-medium"
          title=""
          @click.stop="openExportTemplate">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line stroke="currentColor" x1="8.57666" y1="0.617188" x2="8.57666" y2="10.382" stroke-linecap="round" />
            <path stroke="currentColor" d="M4.29443 6.96851L8.62368 11.2977L12.953 6.96847" stroke-linecap="round" />
            <path
              stroke="currentColor"
              d="M1.61963 11.6953V14.0801C1.61963 14.6324 2.06734 15.0801 2.61963 15.0801H14.5821C15.1344 15.0801 15.5821 14.6324 15.5821 14.0801V11.6953"
              stroke-linecap="round" />
            <defs>
              <rect width="16" height="16" fill="#E2E2E2" transform="translate(0.580078 0.160645)" />
            </defs>
          </svg>
          <span class="ml-1">Save Template to Library</span>
        </a>

        <SchedulePublishBtnVue :is-scheduling-publish="isSchedulingPublish" :click="openSchedulePublish" />
        <a
          id="gf-settings-headnfoot"
          class="gf_action-item dropdown_item typo-button14 typo-medium"
          title=""
          @click.stop="openSettingsModal">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.40023 15.9999C5.00022 15.9999 4.50019 15.7999 4.20018 15.4999C3.80016 15.0999 3.60016 14.5999 3.60016 14.0999V13.1999C3.60016 12.9999 3.50015 12.7999 3.40015 12.5999C3.30014 12.3999 3.10013 12.2999 2.80012 12.2999H1.80008C1.30006 12.2999 0.900039 12.1999 0.500022 11.7999C0.200009 11.5999 0 11.0999 0 10.6999C0 10.1999 0.200009 9.5999 0.600026 9.2999L1.30006 8.6999C1.60007 8.3999 1.70007 7.8999 1.40006 7.5999L0.600026 6.7999C0.200009 6.4999 0 5.9999 0 5.4999C0 4.9999 0.100004 4.5999 0.500022 4.1999C0.900039 3.7999 1.40006 3.5999 1.90008 3.5999H2.80012C3.20014 3.5999 3.60016 3.2999 3.60016 2.7999V1.7999C3.60016 0.799902 4.30019 -9.76548e-05 5.30023 -0.100098C5.80025 -0.100098 6.40028 0.0999024 6.70029 0.499902L7.30032 1.1999C7.60033 1.4999 8.10035 1.5999 8.40036 1.2999L9.10039 0.499902C9.80042 -0.200098 10.9005 -0.300098 11.6005 0.399902C12.0005 0.799902 12.2005 1.2999 12.2005 1.7999V2.6999C12.2005 2.8999 12.3005 3.0999 12.4005 3.2999C12.5005 3.4999 12.7005 3.5999 13.0006 3.5999H14.0006C14.5006 3.5999 14.9006 3.6999 15.3007 4.0999C15.8007 4.3999 16.0007 4.8999 16.0007 5.2999C16.0007 5.7999 15.8007 6.3999 15.4007 6.6999L14.7006 7.2999C14.5006 7.3999 14.4006 7.5999 14.4006 7.8999C14.4006 8.0999 14.5006 8.2999 14.6006 8.4999L15.4007 9.1999C16.1007 9.8999 16.2007 10.9999 15.5007 11.7999C15.1007 12.1999 14.6006 12.3999 14.1006 12.3999H13.2006C12.8006 12.3999 12.4005 12.6999 12.4005 13.1999V14.1999C12.4005 14.6999 12.3005 15.0999 11.9005 15.4999C11.6005 15.8999 11.1005 16.0999 10.6005 16.0999C10.1004 16.0999 9.60041 15.8999 9.2004 15.4999L8.60037 14.7999C8.50037 14.5999 8.30036 14.4999 8.00035 14.4999C7.80034 14.4999 7.60033 14.5999 7.40032 14.6999L6.70029 15.4999C6.40028 15.7999 6.00026 15.9999 5.40023 15.9999C5.50024 15.9999 5.50024 15.9999 5.40023 15.9999ZM2.90013 11.2999H3.00013C3.50015 11.2999 3.90017 11.4999 4.20018 11.8999C4.50019 12.2999 4.7002 12.6999 4.7002 13.1999V14.0999C4.7002 14.2999 4.80021 14.5999 5.00022 14.6999C5.10022 14.8999 5.30023 14.9999 5.50024 14.9999C5.70025 14.9999 5.90025 14.8999 6.10026 14.6999L6.70029 13.9999L6.80029 13.8999C7.20031 13.5999 7.60033 13.3999 8.10035 13.3999C8.60037 13.3999 9.00039 13.5999 9.3004 13.9999L9.90043 14.6999C10.1004 14.8999 10.3004 14.9999 10.5005 14.9999C10.7005 14.9999 10.9005 14.8999 11.1005 14.6999C11.2005 14.4999 11.3005 14.2999 11.3005 14.0999V13.1999C11.3005 13.0999 11.3005 13.0999 11.3005 12.9999C11.4005 11.9999 12.2005 11.1999 13.2006 11.2999H14.1006C14.3006 11.2999 14.6006 11.1999 14.7006 10.9999C14.8006 10.7999 14.9006 10.5999 14.9006 10.3999C14.9006 10.1999 14.8006 9.9999 14.6006 9.7999L14.0006 9.2999L13.9006 9.1999C13.6006 8.7999 13.4006 8.3999 13.4006 7.8999C13.4006 7.3999 13.7006 6.9999 14.0006 6.6999L14.7006 5.9999C14.9006 5.8999 15.0006 5.5999 15.0006 5.3999C15.0006 5.1999 14.9006 4.9999 14.7006 4.7999C14.5006 4.6999 14.3006 4.5999 14.1006 4.5999H13.2006C13.1006 4.5999 13.1006 4.5999 13.0006 4.5999C12.5005 4.5999 12.1005 4.3999 11.8005 3.9999C11.5005 3.5999 11.3005 3.1999 11.3005 2.6999V1.7999C11.3005 1.5999 11.2005 1.2999 11.0005 1.1999C10.7005 0.899902 10.2004 0.899902 9.90043 1.2999L9.3004 1.9999L9.2004 2.0999C8.50037 2.7999 7.30031 2.6999 6.70029 1.9999L6.00026 1.2999C5.90025 1.0999 5.60024 0.999902 5.40023 0.999902C5.00022 0.999902 4.6002 1.3999 4.6002 1.8999V2.7999C4.6002 2.8999 4.6002 2.8999 4.6002 2.9999C4.6002 3.9999 3.80016 4.6999 2.80012 4.6999H1.90008C1.70007 4.6999 1.40006 4.7999 1.30006 4.9999C1.10005 5.0999 1.00004 5.2999 1.00004 5.4999C1.00004 5.6999 1.10005 5.8999 1.30006 5.9999L2.00009 6.6999L2.10009 6.7999C2.80012 7.4999 2.70012 8.6999 2.00009 9.2999L1.30006 9.9999C1.10005 10.0999 1.00004 10.3999 1.00004 10.5999C1.00004 10.7999 1.10005 10.9999 1.30006 11.1999C1.50006 11.2999 1.70007 11.3999 1.90008 11.3999L2.90013 11.2999C2.80012 11.2999 2.80012 11.2999 2.90013 11.2999Z"
              fill="#E2E2E2" />
            <path
              d="M8.00015 11.5002C7.10011 11.5002 6.20007 11.1002 5.50004 10.5002C4.80001 9.8002 4.5 9.0002 4.5 8.0002C4.5 7.1002 4.90002 6.2002 5.50004 5.5002C6.9001 4.1002 9.1002 4.1002 10.4003 5.5002C11.1003 6.2002 11.4003 7.0002 11.4003 8.0002C11.4003 8.9002 11.0003 9.8002 10.4003 10.5002C9.80023 11.2002 8.90019 11.5002 8.00015 11.5002ZM8.00015 5.5002C7.40013 5.5002 6.70009 5.7002 6.20007 6.2002C5.80006 6.7002 5.50004 7.3002 5.50004 8.0002C5.50004 8.7002 5.80006 9.3002 6.20007 9.8002C7.10011 10.7002 8.80019 10.7002 9.70022 9.8002C10.2002 9.3002 10.4003 8.7002 10.4003 8.0002C10.4003 7.3002 10.1002 6.7002 9.70022 6.2002C9.30021 5.7002 8.60018 5.5002 8.00015 5.5002Z"
              fill="#E2E2E2" />
          </svg>

          <span class="ml-1">Publish Settings</span>
        </a>
        <a
          id="gf-settings-headnfoot"
          class="gf_action-item dropdown_item typo-button14 typo-medium"
          title=""
          @click.stop="openShortcutModal">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14 4H2V12H14V4ZM2 3C1.44772 3 1 3.44772 1 4V12C1 12.5523 1.44772 13 2 13H14C14.5523 13 15 12.5523 15 12V4C15 3.44772 14.5523 3 14 3H2ZM4 10.5C4 10.2239 4.22386 10 4.5 10H11.5C11.7761 10 12 10.2239 12 10.5C12 10.7761 11.7761 11 11.5 11H4.5C4.22386 11 4 10.7761 4 10.5ZM4.25 9C4.66421 9 5 8.66421 5 8.25C5 7.83579 4.66421 7.5 4.25 7.5C3.83579 7.5 3.5 7.83579 3.5 8.25C3.5 8.66421 3.83579 9 4.25 9ZM7.5 8.25C7.5 8.66421 7.16421 9 6.75 9C6.33579 9 6 8.66421 6 8.25C6 7.83579 6.33579 7.5 6.75 7.5C7.16421 7.5 7.5 7.83579 7.5 8.25ZM9.25 9C9.66421 9 10 8.66421 10 8.25C10 7.83579 9.66421 7.5 9.25 7.5C8.83579 7.5 8.5 7.83579 8.5 8.25C8.5 8.66421 8.83579 9 9.25 9ZM12.5 8.25C12.5 8.66421 12.1642 9 11.75 9C11.3358 9 11 8.66421 11 8.25C11 7.83579 11.3358 7.5 11.75 7.5C12.1642 7.5 12.5 7.83579 12.5 8.25ZM3.5 6.5C3.91421 6.5 4.25 6.16421 4.25 5.75C4.25 5.33579 3.91421 5 3.5 5C3.08579 5 2.75 5.33579 2.75 5.75C2.75 6.16421 3.08579 6.5 3.5 6.5ZM6.5 5.75C6.5 6.16421 6.16421 6.5 5.75 6.5C5.33579 6.5 5 6.16421 5 5.75C5 5.33579 5.33579 5 5.75 5C6.16421 5 6.5 5.33579 6.5 5.75ZM8 6.5C8.41421 6.5 8.75 6.16421 8.75 5.75C8.75 5.33579 8.41421 5 8 5C7.58579 5 7.25 5.33579 7.25 5.75C7.25 6.16421 7.58579 6.5 8 6.5ZM11 5.75C11 6.16421 10.6642 6.5 10.25 6.5C9.83579 6.5 9.5 6.16421 9.5 5.75C9.5 5.33579 9.83579 5 10.25 5C10.6642 5 11 5.33579 11 5.75ZM12.5 6.5C12.9142 6.5 13.25 6.16421 13.25 5.75C13.25 5.33579 12.9142 5 12.5 5C12.0858 5 11.75 5.33579 11.75 5.75C11.75 6.16421 12.0858 6.5 12.5 6.5Z"
              fill="#E2E2E2" />
          </svg>
          <span class="ml-1">Shortcuts</span>
        </a>
        <!-- <a id="gf-settings-share" class="gf_action-item dropdown_item disabled typo-button14 typo-medium" title="">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.50007 6C3.22391 6 3.00004 6.22386 3.00004 6.5V14.5C3.00004 14.7761 3.22391 15 3.50007 15H12.5005C12.7766 15 13.0005 14.7761 13.0005 14.5V6.5C13.0005 6.22386 12.7766 6 12.5005 6H11.5004C11.2243 6 11.0004 5.77614 11.0004 5.5C11.0004 5.22386 11.2243 5 11.5004 5H12.5005C13.3289 5 14.0005 5.67157 14.0005 6.5V14.5C14.0005 15.3284 13.3289 16 12.5005 16H3.50007C2.6716 16 2 15.3284 2 14.5V6.5C2 5.67157 2.6716 5 3.50007 5H4.50011C4.77626 5 5.00013 5.22386 5.00013 5.5C5.00013 5.77614 4.77626 6 4.50011 6H3.50007Z" fill="currentColor" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00049 0C8.27663 0 8.50049 0.223858 8.50049 0.5V7.5C8.50049 7.77614 8.27663 8 8.00049 8C7.72435 8 7.50049 7.77614 7.50049 7.5V0.5C7.50049 0.223858 7.72435 0 8.00049 0Z" fill="currentColor" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.64656 0.146447C7.84183 -0.0488155 8.15843 -0.0488155 8.3537 0.146447L10.8538 2.64645C11.0491 2.84171 11.0491 3.15829 10.8538 3.35355C10.6585 3.54882 10.3419 3.54882 10.1467 3.35355L8.00013 1.20711L5.85359 3.35355C5.65832 3.54882 5.34172 3.54882 5.14645 3.35355C4.95118 3.15829 4.95118 2.84171 5.14645 2.64645L7.64656 0.146447Z" fill="currentColor" />
          </svg>
          <span class="ml-1">Share (Soon)</span>
        </a> -->
      </div>
    </button>

    <ScheduleModal
      v-if="modals.schedule"
      :g-id="scheduleData.gId"
      :type="scheduleData.type"
      :publish="scheduleData.publish"
      :make-default="scheduleData.makeDefault"
      @cancel="closeModal('schedule')" />
    <UpgradePlanModal v-if="modals.upgrade" m-class="gf_upgrade-plan-modal" @cancel="closeModal('upgrade')" />
    <PageSettingModal
      v-if="modals.settings"
      :section-id="sessionIdOfPageSetting"
      :setting-url="allowPageSettingUrl"
      @cancel="closeModal('settings')" />
    <ShortcutModal v-if="isShowShortcutModal" @cancel="closeModal('shortcut')" />
    <Toast
      v-if="toast && !modals.settings"
      v-bind="toast.attribute"
      class="toast"
      @onClose="dynamicToastClose"
      @action="dynamicToastAction">
      <template #description>{{ toast.message }}</template>
    </Toast>
    <PublishLimitPopup
      v-show="showLimitPublishPopup"
      @close="toggleShowLimitPublishPopup"
      @toggleUnpublishPopup="onOpenUnpublishPopup" />
    <UnpublishPopup v-if="isOpenUnpublishPopup" @close="onCloseUnpublishPopup" />
  </div>
</template>

<script lang="ts">
import type { Component } from 'vue';
import config from '@/app/editor/config';
import { mutations } from '@/store/iframe/types';
import { mutations as appMutations, actions as appActions } from '@/store/app/types';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import { mutations as libraryMutations } from '@modules/libraries/store/types';
import Toast from '@/core/components/base/Toast.vue';
import { defineComponent } from 'vue';
import { $divTopBar, $gryffEditor, $jQuery } from '@/app/index';
import HELPER from '@/app/utils/HELPER';
import { addParamsToUrl, isInIframe } from '@/app/utils/helpers';
import ScheduleModal from './ScheduleModal.vue';
import store from '@/app/store/store';
import UpgradePlanModal from '@/views/Navbar/UpgradePlanModal.vue';
import ShortcutModal from '@/views/Navbar/ShortcutModal.vue';
import PageSettingModal from '@/views/Navbar/PageSettingsModal/index.vue';
import { EDITOR_EVENT } from '@/app/editor/config/constants/trackEventIds';
import { actions as commonActions } from '@/store/common/types';
import { MutationTypes as gemMeterMutations, isLandingPage, CHECK_LIST } from '@/modules/gem-meter';
import { GEM_METER_TRIGGER_EVENT } from '@/modules/gem-meter/constants';
import SchedulePublishBtnVue from './SchedulePublishBtn.vue';
import { PAGE_TYPES, PLAN_NAMES } from '@modules/common';
import { handleAddToLibrary } from '@/app/editor/sidebar/utils/validateAddToLibrary';
import { MODULE_NAME as UNPUBLISH_MODULE_NAME } from '@/modules/unpublish';
import {
  enableNavBarAction,
  mutationTypes as unpublishMutationTypes,
  getterTypes as unpublishGetterTypes,
} from '@/modules/unpublish';
import emitter from '@/emitter';
import goToPricing from '@/mixins/goToPricing';
import { useListenMessageTriggerSave } from './hooks/useListenMessageTriggerSave';
import { useRecordPagesBannerAction } from './hooks/useRecordPagesBannerAction';

const PublishLimitPopup = defineAsyncComponent<Component>(
  () => import('@/modules/unpublish/components/PublishLimitPopup.vue'),
);
const UnpublishPopup = defineAsyncComponent<Component>(
  () => import('@/modules/unpublish/components/UnpublishPopup/index.vue'),
);

const PAGE_SETTING_SESSION = {
  seo_setting: 'seo_setting',
  social_sharing: 'social_sharing',
  advanced_setting: 'advanced_setting',
  layout_setting: 'layout_setting',
};

export default defineComponent({
  name: 'NavbarActions',
  components: {
    UpgradePlanModal,
    ScheduleModal,
    PageSettingModal,
    ShortcutModal,
    Toast,
    SchedulePublishBtnVue,
    PublishLimitPopup,
    UnpublishPopup,
  },
  mixins: [goToPricing],
  data: () => ({
    dropdownActive: false,
    pageSettingWarnPayload: {
      target: 'pageSettingWarn',
      attribute: {
        type: 'warn',
        isInline: true,
        isClose: true,
        actionTitle: 'Remind me later',
      },
      message: "Please Publish again to apply changes you've made in Publish Setting to Live Page.",
    },
    pageSettingInfoPayload: {
      target: 'pageSettingInfo',
      attribute: {
        type: 'infor',
        isClose: true,
      },
      message: "Changes you've made in Publish Setting will be applied to your Live Page as soon as it's published.",
    },
    modals: {
      schedule: false,
      upgrade: false,
      settings: false,
    },
    schedule: {
      publish: {
        socketListening: false,
        running: false,
        percentage: 0,
        currentPercent: 0,
        interval: -1,
        INTERVAL: 33,
        timeout: -1,
      },
    },
    showLimitPublishPopup: false,
    unpublishStep: 0,
    unpublishTimeout: undefined as any,
    sessionIdOfPageSetting: '',
  }),
  computed: {
    ...mapGetters('app', {
      pageType: 'pageType',
      pagePlan: 'pagePlan',
      pageGID: 'pageGID',
      shopifyDomain: 'shopifyDomain',
      gemMeterOBD: 'gemMeterOBD',
      publishedPage: 'publishedPage',
      limitPublishPage: 'limitPublishPage',
      isLimitPublish: 'isLimitPublish',
    }),
    ...mapGetters('page', {
      currentPageHandle: 'currentPageHandle',
      settingChangedList: 'settingChangedList',
      getProductDynamic: 'GET_PRODUCT_DYNAMIC',
    }),
    ...mapState('app', {
      pageInfo: 'pageInfo',
      shopInfo: 'shopInfo',
      isSaved: 'isSaved',
      isMakeDefault: 'isMakeDefault',
      showPageSettingModal: 'showPageSettingModal',
      showMobileFistWarning: 'showMobileFistWarning',
      toast: 'navBarToast',
    }),
    ...mapState('editor', {
      isShowShortcutModal: 'showShortcutModal',
      isLoadingDynamicData: 'isLoadingDynamicData',
      isLoadingEditor: 'isLoadingEditor',
    }),
    ...mapState('library', {
      modalLayout: (state: any): string => state.layout,
    }),
    ...mapState('page', {
      assignedProduct: 'assignedProduct',
    }),
    ...mapGetters(UNPUBLISH_MODULE_NAME, {
      isOpenUnpublishPopup: unpublishGetterTypes.GET_IS_OPEN_POPUP,
      isUsingWebSocket: unpublishGetterTypes.GET_IS_USING_WEB_SOCKET,
    }),
    isPageSettingToast() {
      return this.settingChangedList?.includes(this.pageGID);
    },
    showUpgrade() {
      if (!this.shopInfo || this.shopInfo.plan == PLAN_NAMES.TRIAL || this.shopInfo.plan == PLAN_NAMES.TRIAL_2022) {
        return true;
      }
      return false;
    },
    shouldShowPreviewTemplate() {
      const page = this.pageInfo?.page;
      if (['template-page', 'template-article'].includes(page?.type)) {
        return false;
      }
      if (!this.isMakeDefault) {
        if (['template-collection', 'template-index'].includes(page?.type)) {
          return true;
        }
        let $product = $gryffEditor().find(
          '[data-label="Product"][data-status="dynamic"],[data-label="Product"][data-status="default"]',
        );
        if ($product.length > 0) {
          const href = $divTopBar().find('#gf-view').attr('origin-href') || '';
          const productHandle = href.split('/').pop();
          for (let index = 0; index < $product.length; index++) {
            if ($jQuery($product[index]).children('.module').attr('data-phandle') == productHandle) {
              $product = $jQuery($product[index]);
              break;
            }
          }
        }
        const pid = $product.children('.module').attr('data-pid');
        const productData: any = HELPER.searchProductInList(pid);
        const namePageTemplate = page?.handle;
        // eslint-disable-next-line camelcase
        return productData?.template_suffix != namePageTemplate;
      }
      return false;
    },
    shouldDisablePublish() {
      // eslint-disable-next-line camelcase
      if (typeof this.pageInfo?.campaign_id == 'number') {
        return true;
      }
      return false;
    },
    scheduleData() {
      const output: any = {
        type: (this.pageInfo?.page?.type || '').replace('template-', ''),
        templateId: null,
        revert: undefined,
        publish: undefined,
        makeDefault: undefined,
        // eslint-disable-next-line camelcase
        gId: this.pageInfo?.page?.g_id,
      };
      if (this.pageInfo?.page?.events?.length) {
        const publishEvent = this.pageInfo.page.events.find((x: any) => x.event == 'schedule_publish');
        // eslint-disable-next-line camelcase
        output.publish = publishEvent?.event_at;
        // eslint-disable-next-line camelcase
        output.makeDefault = publishEvent?.make_default;
      }
      return output;
    },
    isSchedulingPublish() {
      if (this?.scheduleData?.publish) {
        return true;
      }
      return false;
    },
    isAdvancedPlan() {
      return this.shopInfo?.plan === 'advanced';
    },
    overlayStyle() {
      return {
        width: this.schedule.publish.currentPercent + '%',
      };
    },
    shouldDisableSchedulePublish() {
      return this.shouldDisablePublish;
    },
    allowPageSettingUrl() {
      if (!this.pageInfo) return false;
      const pageType = this.pageInfo.page.type as string;
      return ['template-page', 'template-article'].includes(pageType);
    },
    updatedSettingPageList() {
      const list = localStorage.getItem('updateSettingList');
      return list ? JSON.parse(list) : [];
    },
    mobileFirstPageList() {
      const list = localStorage.getItem('mobileFirstList');
      return list ? JSON.parse(list) : [];
    },
    isLockSavePublish() {
      return this.isLoadingEditor || this.isLoadingDynamicData;
    },
    isDisabledViewLivePage() {
      const pageType = this.pageInfo?.page?.type;
      const isPublished = this.pageInfo?.page?.isPublished;
      const totalAssigned = this.assignedProduct.list.length;
      if (pageType == 'template-product') {
        return !isPublished || !totalAssigned;
      }
      return !isPublished;
    },
    isInIframe() {
      return isInIframe();
    },
  },
  watch: {
    isSchedulingPublish(newV, oldV) {
      if (newV == oldV) {
        return;
      }
      this.checkPublishSettingAlert(newV);
      this.checkSchedule();
    },
    pageGID(newV, oldV) {
      if (newV == oldV) {
        return;
      }
      const pageId = this.pageGID;
      const list = this.updatedSettingPageList as Array<string>;
      if (list.includes(pageId)) {
        (this as any).$store.commit('page/ADD_SETTING_CHANGED_LIST', pageId);
      }
    },
    showPageSettingModal: {
      immediate: true,
      handler(newV, oldV) {
        if (newV === oldV) {
          return;
        }
        if (newV === true) {
          this.openSettingsModal();
        } else {
          this.closeModal('settings');
        }
      },
    },
    isShowShortcutModal: {
      immediate: true,
      handler(newV, oldV) {
        if (newV === oldV) {
          return;
        }
        if (newV === true) {
          this.openShortcutModal();
        } else {
          this.closeModal('shortcut');
        }
      },
    },
    settingChangedList() {
      this.handlePageSettingToast();
    },
    isUsingWebSocket(newValue, oldValue) {
      if (!oldValue && newValue) {
        if (window._webSocket && window._webSocket.connection.readyState === 1) {
          window._webSocket.onmessage('page_unpublish_processing', (data: any) => {
            if (this.unpublishTimeout) {
              clearTimeout(this.unpublishTimeout);
            }

            // Wait 30 seconds before auto mark as complete on front-end
            const self = this;
            this.unpublishTimeout = setTimeout(() => {
              self.handleUnpublishSuccess(totalSteps);
            }, 30000);
            const { totalSteps } = data;
            this.unpublishStep += 1;
            if (this.unpublishStep != totalSteps) {
              return;
            }

            this.handleUnpublishSuccess(totalSteps);
            clearTimeout(this.unpublishTimeout);
          });
        }
      }
    },
  },
  created() {
    useListenMessageTriggerSave();
    useRecordPagesBannerAction();

    this.handlePageSettingToast();
    // ===== GemMeter Feature ===== //
    emitter.off('gem-meter:manual-open-modal-setting');
    //@ts-ignore
    emitter.on('gem-meter:manual-open-modal-setting', (type: string) => {
      if (type === CHECK_LIST.MISSING_LAZY_LOADING.id) {
        this.sessionIdOfPageSetting = PAGE_SETTING_SESSION.advanced_setting;
      }
      if (type === CHECK_LIST.WEAK_SEO.id) {
        this.sessionIdOfPageSetting = PAGE_SETTING_SESSION.seo_setting;
      }
      this.openSettingsModal();
    });
    // =========================== //
  },
  methods: {
    ...mapMutations('iframe', {
      toggleOverlay: mutations.TOGGLE_OVERLAY,
      alert: mutations.ALERT,
    }),
    ...mapMutations('app', {
      removeEvent: appMutations.CANCEL_PAGE_EVENT,
      addNavBarToast: appMutations.ADD_NAVBAR_TOAST,
      removeNavBarToast: appMutations.REMOVE_NAVBAR_TOAST,
      decreasePublishProductPage: appMutations.DECREASE_NUMBER_OF_PUBLISHED_PRODUCT_PAGE,
      decreasePublishArticlePage: appMutations.DECREASE_NUMBER_OF_PUBLISHED_ARTICLE_PAGE,
      decreasePublishPage: appMutations.DECREASE_NUMBER_OF_PUBLISHED_PAGE,
    }),
    ...mapActions('app', {
      getPageInfo: appActions.GET_PAGE_INFO,
    }),
    ...mapMutations('library', {
      // toggleLibraryModal: libraryMutations.TOGGLE,
      // changeLayout: libraryMutations.CHANGE_LAYOUT,
      openCreateLib: libraryMutations.OPEN_CREATE_LIB,
    }),
    ...mapActions('common', {
      trackEvent: commonActions.TRACK_EVENT,
    }),
    ...mapMutations('gemMeter', {
      changeGemMeterModalVisible: gemMeterMutations.CHANGE_MODAL_VISIBILITY,
    }),
    ...mapMutations(UNPUBLISH_MODULE_NAME, {
      setOpenUnpublishModal: unpublishMutationTypes.SET_IS_OPEN_MODAL,
      resetUnpublishData: unpublishMutationTypes.RESET_UNPUBLISH_DATA,
    }),
    dynamicToastClose() {
      switch (this.toast.target) {
        case 'mobileFirst':
          return this.closeMobileFirstWarning;
        case 'pageSettingWarn':
          return this.closeSettingChangeWarning;
        case 'pageSettingInfo':
          return this.removePageFromStore;
      }
      return false;
    },
    dynamicToastAction() {
      switch (this.toast.target) {
        case 'pageSettingWarn':
          return this.removePageFromStore;
        default:
          break;
      }
      return false;
    },
    openModal(type: string) {
      (this.modals as any)[type] = true;
    },
    closeModal(type: string) {
      (this.modals as any)[type] = false;
      this.sessionIdOfPageSetting = '';
      if (type == 'settings') {
        (this as any).$store.commit('app/SHOW_PAGE_SETTING_MODAL', false);
      }
      if (type == 'shortcut') {
        (this as any).$store.commit('editor/SHOW_SHORTCUT_MODAL', false);
      }
    },
    bindingData(urlType: string) {
      let objUrl = {} as any;
      const params = {
        _ab: 0,
        key: new Date().getTime(),
      };
      const PREVIEW_URL_SEGMENT = import.meta.env.VITE_APP_PREVIEW_URL_SEGMENT || 'gempages';
      if (this.pageType && this.pageType == 'template-page') {
        objUrl = {
          liveUrl: addParamsToUrl(`//${this.shopifyDomain}/pages/${this.currentPageHandle}`, params),
          previewUrl: encodeURI(
            decodeURI(
              addParamsToUrl(`//${this.shopifyDomain}/a/${PREVIEW_URL_SEGMENT}`, {
                preview: this.pageInfo.page.g_id,
                type: 'template-page',
                page: this.currentPageHandle,
              }),
            ),
          ),
          upgradeUrl: this.pricingUrl,
          templateUrl: addParamsToUrl(`//${this.shopifyDomain}/pages/${this.currentPageHandle}`, {
            ...params,
            view: `gem-${this.pageInfo.page.g_id}-template`,
            live: 'true',
          }),
        };

        return objUrl[`${urlType}`];
      }

      objUrl = {
        // eslint-disable-next-line camelcase
        liveUrl: addParamsToUrl(this.pageInfo?.page?.shopify_page_url || '', params),
        // eslint-disable-next-line camelcase
        previewUrl: encodeURI(decodeURI(`${this.pageInfo?.page?.preview_url}` || '')),
        upgradeUrl: this.pricingUrl,
        // eslint-disable-next-line camelcase
        templateUrl: this.pageInfo?.page?.shopify_page_url
          ? addParamsToUrl(this.pageInfo?.page?.shopify_page_url, {
              ...params,
              view: `gem-${this.pageInfo.page.g_id}-template`,
              live: 'true',
            })
          : '',
      };

      return objUrl[`${urlType}`];
    },
    setPreviewViewUrl() {
      if (this.getProductDynamic && this.getProductDynamic.handle) {
        HELPER.setPreviewViewUrl(this.getProductDynamic.handle);
      }
    },
    previewPage() {
      this.setPreviewViewUrl();
      // ===== GemMeter Feature ===== //
      if (isLandingPage()) {
        if (!this.gemMeterOBD) {
          this.changeGemMeterModalVisible(true);
        }
      }
      // =========================== //
    },
    viewPage(liveUrl: any, event: any) {
      if (
        event.target.classList.contains('gf-disabled_action') ||
        event.target.parentElement?.classList.contains('gf-disabled_action')
      ) {
        this.openDropdown();
      } else {
        window.open(liveUrl, '_blank');
      }
    },
    viewTemplate(templateUrl: any, event: any) {
      if (
        event.target.classList.contains('gf-disabled_action') ||
        event.target.parentElement?.classList.contains('gf-disabled_action')
      ) {
        this.openDropdown();
      } else {
        window.open(templateUrl, '_blank');
      }
      const page = this.pageInfo?.page;
      if (['template-page', 'template-article'].includes(page?.type)) {
        return true;
      }
      if (!this.isMakeDefault) {
        if (['template-collection', 'template-index'].includes(page?.type)) {
          return false;
        }
        let $product = $gryffEditor().find(
          '[data-label="Product"][data-status="dynamic"],[data-label="Product"][data-status="default"]',
        );
        if ($product.length > 0) {
          const href = $divTopBar().find('#gf-view').attr('origin-href') || '';
          const productHandle = href.split('/').pop();
          for (let index = 0; index < $product.length; index++) {
            if ($jQuery($product[index]).children('.module').attr('data-phandle') == productHandle) {
              $product = $jQuery($product[index]);
              break;
            }
          }
        }
        const pid = $product.children('.module').attr('data-pid');
        const productData: any = HELPER.searchProductInList(pid);
        const namePageTemplate = page?.handle;
        // eslint-disable-next-line camelcase
        return !(productData?.template_suffix != namePageTemplate);
      }
      return true;
    },
    savePage() {
      this.trackEvent({ eventId: EDITOR_EVENT.SAVE_CLICKED, properties: {} });
    },
    publishPage(event: Event) {
      const publishBtn = document.getElementById('gf-publish');
      if (!publishBtn) {
        return;
      }

      if (
        publishBtn &&
        (publishBtn.classList.contains('gf-disabled_action') || publishBtn.getAttribute('lock') === 'true')
      ) {
        return;
      }

      if (!this.isLimitPublish) {
        return;
      }

      if (this.publishedPage >= this.limitPublishPage && this.publishedPage > 0) {
        event.stopPropagation();
        this.showLimitPublishPopup = true;
      }
    },
    toggleShowLimitPublishPopup() {
      this.showLimitPublishPopup = !this.showLimitPublishPopup;
    },
    onCloseUnpublishPopup() {
      this.setOpenUnpublishModal(false);
    },
    onOpenUnpublishPopup() {
      this.toggleShowLimitPublishPopup();
      this.setOpenUnpublishModal(true);
    },
    openUpgrade() {},
    toggleDropdown(event: any) {
      let value = !this.dropdownActive;
      const isClickLockPreview =
        (event.target.getAttribute('id') == 'gf-preview' && event.target.getAttribute('lock')) ||
        (event.target.parentElement?.getAttribute('id') == 'gf-preview' &&
          event.target.parentElement?.getAttribute('lock')) ||
        (event.target.getAttribute('id') == 'gf-preview' && event.target.classList.contains('gf-disabled_action')) ||
        (event.target.parentElement?.getAttribute('id') == 'gf-preview' &&
          event.target.parentElement?.classList.contains('gf-disabled_action'));
      const isClickLockView =
        (event.target.getAttribute('id') == 'gf-view' && event.target.classList.contains('gf-disabled_action')) ||
        (event.target.parentElement?.getAttribute('id') == 'gf-view' &&
          event.target.parentElement?.classList.contains('gf-disabled_action'));
      const isClickLockViewTemplate =
        (event.target.getAttribute('id') == 'gf-viewtemplate' &&
          event.target.classList.contains('gf-disabled_action')) ||
        (event.target.parentElement?.getAttribute('id') == 'gf-viewtemplate' &&
          event.target.parentElement?.classList.contains('gf-disabled_action'));

      if (isClickLockPreview || isClickLockView || isClickLockViewTemplate) {
        value = true;
      }
      this.dropdownActive = value;
      $jQuery('#divTopBar #gf-publish')?.data('gftooltipsnew')?.stop();
      this.changeGemMeterModalVisible(false);
      this.toggleOverlay(this.dropdownActive);
    },
    openDropdown() {
      this.dropdownActive = true;
      this.changeGemMeterModalVisible(false);
      this.toggleOverlay(true);
      return true;
    },
    closeDropdown() {
      this.dropdownActive = false;
      this.toggleOverlay(false);
      return false;
    },
    checkPublishSettingAlert(isSchedule: boolean) {
      if (!this.isPageSettingToast) return;
      if (isSchedule) {
        this.addNavBarToast(this.pageSettingInfoPayload);
      } else {
        this.addNavBarToast(this.pageSettingWarnPayload);
      }
    },
    removePageIdLocalStorage(value: string, list: any) {
      const index = list.indexOf(this.pageGID);
      if (index !== -1) list.splice(index, 1);
      localStorage.setItem(value, JSON.stringify(list));
    },
    removeUpdatedSettingPage() {
      this.removePageIdLocalStorage('updateSettingList', this.updatedSettingPageList);
    },
    removeMobileFirstPage() {
      const pageId = this.pageGID;
      const listItem = localStorage.getItem('closedMobileFirstList');
      const list = listItem ? JSON.parse(listItem) : [];
      if (!list.includes(pageId)) {
        list.push(pageId);
      }
      localStorage.setItem('closedMobileFirstList', JSON.stringify(list));
    },
    removePageFromStore() {
      (this as any).$store.commit('page/REMOVE_SETTING_CHANGED_LIST', this.pageGID);
    },
    closeSettingChangeWarning() {
      this.removeUpdatedSettingPage();
      this.removePageFromStore();
    },
    closeMobileFirstWarning() {
      this.removeMobileFirstPage();
    },
    handlePageSettingToast() {
      const payload = this.isSchedulingPublish ? this.pageSettingInfoPayload : this.pageSettingWarnPayload;
      if (this.isPageSettingToast) {
        this.addNavBarToast(payload);
      } else {
        this.removeNavBarToast();
      }
    },
    checkSchedule() {
      if (this.isSchedulingPublish) {
        if (this.schedule.publish.socketListening) {
          return;
        }
        this.schedule.publish.socketListening = true;
        window._webSocket.onmessage('page_publish_processing', (data: any) => {
          const source = this.schedule.publish;
          source.running = true;
          // eslint-disable-next-line camelcase
          if (!(this.pageInfo?.page?.g_id == data.pageID && this.pageInfo?.page?.type == data.pageType)) {
            this.schedule.publish.socketListening = false;
            window._webSocket.offmessage('page_publish_processing');
            return;
          }

          if (data.status == 'error') {
            this.schedule.publish.socketListening = false;
            window._webSocket.offmessage('page_publish_processing');
            HELPER.showNotify('Data update Failed, please try again later.', 'error');
            source.running = false;
            return;
          }
          const step = data.currentStep;
          const total = data.totalSteps;
          source.percentage = Math.round((100 * step) / total);
          clearInterval(source.interval);
          // $progressMessage.text(data.message);
          if (source.percentage >= 100) {
            clearTimeout(source.timeout);
            HELPER.showNotify('Data published Successfully.', 'success');
            store.setValue('__isPublished', true);
            const pageId = this.pageGID;
            this.removeUpdatedSettingPage();
            (this as any).$store.commit('page/REMOVE_SETTING_CHANGED_LIST', pageId);
            // $modalProgress.removeClass("show");
            source.running = false;
            // ===== GemMeter Feature ===== //
            emitter.emit('gem-meter:trigger-rules', GEM_METER_TRIGGER_EVENT.SAVE_PAGE);
            // ===== GemMeter Feature ===== //

            this.removeEvent({
              type: `template-${this.scheduleData.type}`,
              event: 'schedule_publish',
              id: this.scheduleData.gId,
              fields: {
                eventAt: 'event_at',
              },
            });
            this.schedule.publish.socketListening = false;
            window._webSocket.offmessage('page_publish_processing');
          } else {
            const percentTo = Math.round((100 * (step + 1)) / total) - 1;
            source.currentPercent = source.percentage;
            if (source.currentPercent < 0) {
              source.currentPercent = 0;
            }
            source.interval = setInterval(() => {
              source.currentPercent++;
              if (source.currentPercent > percentTo) {
                clearInterval(source.interval);
              }
            }, source.INTERVAL);
          }
        });
      } else {
        if (!this.schedule.publish.socketListening) {
          this.schedule.publish.socketListening = false;
          window._webSocket.offmessage('page_publish_processing');
        }
      }
    },
    openSchedulePublish(isInValid: boolean) {
      if (isInValid) {
        // HELPER.showNotify("Sorry, only Advanced users can use the Schedule Publish feature", "error");
        this.openModal('upgrade');
        return;
      }

      this.openModal('schedule');
    },
    openExportTemplate() {
      this.closeDropdown();
      handleAddToLibrary(null, 'template');
    },
    openSettingsModal() {
      this.closeDropdown();
      this.openModal('settings');
      (this as any).$store.commit('app/SHOW_PAGE_SETTING_MODAL', true);
      (this as any).$store.commit('app/DISABLE_HISTORY_ITEM');
    },
    openShortcutModal() {
      this.closeDropdown();
      if (!this.isShowShortcutModal) {
        (this as any).$store.commit('editor/SHOW_SHORTCUT_MODAL', true);
      }
    },
    async handleUnpublishSuccess(totalSteps: string) {
      const message =
        this.publishedPage - parseInt(totalSteps, 10) < this.limitPublishPage
          ? 'Unpublishing successfully. You can now publish this page.'
          : `Unpublishing <b>${totalSteps}</b> successfully.`;
      await this.getPageInfo();
      this.alert({
        show: true,
        title: '',
        message: message,
        typeAlert: 'success',
      });
      if (this.shopInfo.plan == PLAN_NAMES.BUILD) {
        if (this.pageType == PAGE_TYPES.PRODUCT_PAGE) {
          this.decreasePublishProductPage(parseInt(totalSteps, 10));
        } else {
          this.decreasePublishArticlePage(parseInt(totalSteps, 10));
        }
      } else {
        this.decreasePublishPage(parseInt(totalSteps, 10));
      }
      this.resetUnpublishData();
      enableNavBarAction();
      this.unpublishStep = 0;
      window._webSocket.offmessage('page_unpublish_processing');
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';

#gfActions {
  svg {
    vertical-align: unset;
    display: inline;
  }
}
#gf-library-export {
  min-width: 100px;
}
#gf-save,
#gf-preview {
  line-height: 21px;
  padding: 9.5px 24px;
  color: #fff;

  @media (max-width: 1300px) {
    padding: 9.5px 12px;
  }
  &:disabled,
  &.disabled,
  &[lock='true'] {
    cursor: default;
    background: $text-light-low;
    opacity: 0.3;
  }
}
.min-40 {
  min-width: 40px;
}
.min-100 {
  min-width: 100px;
}
.min-140 {
  min-width: 140px;
}

@keyframes spanning-dot {
  from {
    transform: scale(1);
  }
  from {
    transform: scale(1.5);
  }
}

.dropdown_root {
  position: relative;
  &.active {
    background: $dark2;
  }
  .new-feature {
    position: absolute;
    top: 3px;
    right: 3px;
    $size: 10px;
    padding: 2px;
    width: $size;
    height: $size;
    overflow: hidden;
    background: rgba($accent-red, 0.3);
    border-radius: 50%;
    @include flex-center;
    animation: spanning-dot alternate-reverse 1000ms ease infinite;

    &:before {
      content: '';
      width: 100%;
      height: 100%;
      background: $accent-red;
      border-radius: 50%;
    }
  }
}

.toast {
  position: absolute;
  top: 100%;
  right: 0;
  width: 100%;
}

.dropdown_list {
  display: none;
  flex-direction: column;
  position: absolute;
  top: 45px;
  right: 0;
  width: 280px;
  border-radius: $radius;
  background: map-get($hybrid-shade-dark, '300');
  z-index: 2;
  box-shadow:
    0px -2px 8px rgba(0, 0, 0, 0.06),
    0px 2px 8px rgba(0, 0, 0, 0.12);

  &:before {
    content: '';
    position: absolute;
    right: 12px;
    top: -5px;
    border-radius: 3px;
    width: 0px;
    height: 0px;
    border: 8px solid transparent;
    border-top-color: $dark3;
    border-left-color: $dark3;
    background: $dark3;
    transform: rotate(45deg);
    z-index: -1;
  }

  &.show {
    display: flex;
  }
  .btn-upgrade {
    min-height: 40px;
    padding: 12px;
    margin: 8px 8px 0;
    span {
      color: map-get($text-light-mode, 'high-contrast');
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
    }
  }
  .divider {
    background: #d6d6d6;
    opacity: 0.1;
    margin: 8px;
    height: 1px;
  }
  a.disabled {
    cursor: default;
  }
}

.dropdown_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  color: $text-dark-high;
  padding: 12px 16px;
  cursor: pointer;

  &.disabled {
    // background-color: $dark2;
    opacity: 0.4;
    cursor: default;
  }

  &:not(.disabled):hover {
    background-color: $dark2;
  }

  &:not(.disabled).gf-disabled_action:hover {
    background-color: #606569;
  }
}

:deep(#gf-publish) {
  position: relative;

  .progress-bar {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    max-width: calc(100% + 2px);
    min-width: 0%;
    z-index: -1;
    border-radius: $radius 0 0 $radius;
  }

  &.publishing {
    position: relative;
    opacity: 0.9;
    overflow: hidden;
    pointer-events: none;

    .progress-bar {
      display: block;
      background-color: #2b46b6;
      height: 100%;
      box-shadow: 0 0 7px 0px #3b7edc;
    }
  }

  &:disabled {
    cursor: default;
    background: $text-light-low;
    opacity: 0.3;
  }

  &:not(:disabled):hover {
    background: $secondary_1;
  }

  &[lock='true'] {
    background: $primary;
    opacity: 0.6;
    cursor: url('https://assets.gemcommerce.com/v6/editor/images/cursor-not_allowed.png'), auto;

    &:hover {
      background: $primary;
    }
  }
}

.gf-publish-btn {
  padding: 10px 24px;
  span {
    margin-right: 4px;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #fff;
  }
  @media (max-width: 1300px) {
    padding: 9.5px 12px;
  }
}
#gf-publish.gf-disabled_action,
#gf-save.gf-disabled_action,
#gf-preview.gf-disabled_action {
  background: #606569;
  opacity: 0.6;
  cursor: url(https://assets.gemcommerce.com/v6/editor/images/cursor-not_allowed.png), auto !important;
}

.status.tag {
  position: relative;
  // padding-right: 12px;
  &:after {
    content: '';
    $size: 5px;
    position: absolute;
    border-radius: 50%;
    width: $size;
    height: $size;
    background-color: currentColor;
    top: 50%;
    transform: translateY(-50%);
    left: -($size + 5px);
  }
}

.schedule-publishing {
  position: relative;
  pointer-events: none;
  .publish-overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: $mono3;
    opacity: 0.3;
    max-width: 100%;
    border-right: 2px solid;
  }
}
.gethep_top-icon {
  color: $neutral5;
  width: 40px;
  height: 40px;
  border-radius: 3px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #333;
  &:hover {
    background: #424242;
  }
  &.showup {
    animation-name: action_show_up;
    animation-timing-function: linear;
    animation-duration: 1000ms;
    animation-delay: 0;
    // svg.showup-svg{
    //   animation-name: action_svg-show_up;
    //   animation-timing-function: linear;
    //   animation-duration: 1000ms;
    //   animation-delay: 0;
    //   transition: transform 500ms;
    // }
  }
}
@keyframes action_show_up {
  0% {
    background: #061325;
  }
  10% {
    background: #424242;
  }
  100% {
    background: #424242;
  }
}

.advanced {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #fdb913;

  &__icon {
    margin: -8px -8px;
  }
}
</style>
